import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          <li className="software-skill-inline" name="golang">
            <img
              alt="golang"
              style={{width: "48 px", height: "48px"}}
              src={require("../../assets/images/golang.svg").default}
            ></img>
            <p>golang</p>
          </li>
          <li className="software-skill-inline" name="kubernetes">
            <img
              alt="kubernetes"
              style={{width: "48 px", height: "48px"}}
              src={require("../../assets/images/kubernetes.svg").default}
            ></img>
            <p>kubernetes</p>
          </li>
          <li className="software-skill-inline" name="azure">
            <img
              alt="azure"
              style={{width: "48 px", height: "48px"}}
              src={require("../../assets/images/azure.svg").default}
            ></img>
            <p>Azure</p>
          </li>
          <li className="software-skill-inline" name="databricks">
            <img
              alt="databricks"
              style={{width: "48 px", height: "48px"}}
              src={require("../../assets/images/databricks.svg").default}
            ></img>
            <p>Databricks</p>
          </li>
          <li className="software-skill-inline" name="postgresql">
            <img
              alt="postgresql"
              style={{width: "48 px", height: "48px"}}
              src={require("../../assets/images/postgresql.svg").default}
            ></img>
            <p>Postgresql</p>
          </li>

          <li className="software-skill-inline" name="datadog">
            <img
              alt="datadog"
              style={{width: "48 px", height: "48px"}}
              src={require("../../assets/images/datadog.svg").default}
            ></img>
            <p>Datadog</p>
          </li>
          <li className="software-skill-inline" name="terraform">
            <img
              alt="terraform"
              src={require("../../assets/images/terraform.svg").default}
            ></img>
            <p>Terraform</p>
          </li>

          {skillsSection.softwareSkills.map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <i className={skills.fontAwesomeClassname}></i>
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
